<div class="header">
  <div class="header-cont single-area">
    <h2>{{ geopos_current.name[current_lang] }}</h2>
  </div>
</div>

<div #map class="map"></div>

<div class="section-headers">
  <div class="section-headers-cont headers-with-filters">
    <h3>{{ 'single_area.pois' | translate }}</h3>
    <div class="filters">
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title *ngIf="!loadingPoiThemeIcon; else loadingThemePoiDesktop">
            {{ 'poi_list.filter_theme' | translate }}
          </mat-panel-title>
          <ng-template #loadingThemePoiDesktop>
            <mat-panel-title>
              {{ 'poi_list.filter_theme' | translate }}
              <mat-progress-spinner
                  matSuffix
                  color="primary"
                  mode="indeterminate"
                  [diameter]="24"
                  style="margin-left: 5px;">
              </mat-progress-spinner>
            </mat-panel-title>
          </ng-template>
        </mat-expansion-panel-header>
        <mat-selection-list color="primary" class="dropdown-filters" #themesFilterPoiDesktop (selectionChange)="themesFilterFunction('poi', false)">
          <mat-list-option *ngFor="let single_theme of themes_list" [value]="single_theme.name[current_lang]">
            {{single_theme.name[current_lang]}}
          </mat-list-option>
        </mat-selection-list>
      </mat-expansion-panel>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'poi_list.search_label' | translate }}</mat-label>
        <input matInput (keyup)="inputFilter($event, 'poi')" class="input-filter" [placeholder]="'placeholder' | translate">
        <mat-icon *ngIf="!loadingPoiSearchIcon; else loadingSearchPoiDesktop" matSuffix>search</mat-icon>
        <ng-template #loadingSearchPoiDesktop>
          <mat-progress-spinner
              matSuffix
              color="primary"
              mode="indeterminate"
              [diameter]="24">
          </mat-progress-spinner>
        </ng-template>
      </mat-form-field>
    </div>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont headers-with-filters-smaller">
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title *ngIf="!loadingPoiThemeIcon; else loadingThemePoiMobile">
          {{ 'poi_list.filter_theme' | translate }}
        </mat-panel-title>
        <ng-template #loadingThemePoiMobile>
          <mat-panel-title>
            {{ 'poi_list.filter_theme' | translate }}
            <mat-progress-spinner
                matSuffix
                color="primary"
                mode="indeterminate"
                [diameter]="24"
                style="margin-left: 5px;">
            </mat-progress-spinner>
          </mat-panel-title>
        </ng-template>
      </mat-expansion-panel-header>
      <mat-selection-list color="primary" class="dropdown-filters" #themesFilterPoiMobile (selectionChange)="themesFilterFunction('poi', true)">
        <mat-list-option *ngFor="let single_theme of themes_list" [value]="single_theme.name[current_lang]">
          {{single_theme.name[current_lang]}}
        </mat-list-option>
      </mat-selection-list>
    </mat-expansion-panel>
    <mat-form-field appearance="outline">
      <mat-label>{{ 'poi_list.search_label' | translate }}</mat-label>
      <input matInput (keyup)="inputFilter($event, 'poi')" class="input-filter" [placeholder]="'placeholder' | translate">
      <mat-icon *ngIf="!loadingPoiSearchIcon; else loadingSearchPoiMobile" matSuffix>search</mat-icon>
      <ng-template #loadingSearchPoiMobile>
        <mat-progress-spinner
            matSuffix
            color="primary"
            mode="indeterminate"
            [diameter]="24">
        </mat-progress-spinner>
      </ng-template>
    </mat-form-field>
  </div>
</div>

<div class="single-section">
  <div class="section-cont">
    <div *ngIf="!loadingPoi; else loadingPagePoi" class="element-card">
      <mat-card *ngFor="let single_poi of poi_list_filtered | paginate: { itemsPerPage: poi_list_size, currentPage: poi_list_page + 1, totalItems: poi_list_total, id: 'paginationPoi' }" [routerLink]="['/home/poi/' + single_poi.id]">
        <img mat-card-image [src]="imageUrl(single_poi)" [alt]="single_poi.poi_name[current_lang]">
        <mat-card-content>
          <a><h4>{{single_poi.poi_name[current_lang]}}</h4></a>
          <p>{{single_poi.short_descr[current_lang]}}</p>
        </mat-card-content>
      </mat-card>
    </div>
    <ng-template #loadingPagePoi>
      <div class="element-card">
        <mat-progress-spinner
            color="primary"
            mode="indeterminate">
        </mat-progress-spinner>
      </div>
    </ng-template>
    <pagination-controls
      *ngIf="poi_list_total > poi_list_size"
      class="pr-pagination"
      (pageChange)="pageChange($event, true)"
      id="paginationPoi"
      [previousLabel]="'paginator.prev' | translate"
      [nextLabel]="'paginator.next' | translate"
    ></pagination-controls>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont headers-with-filters">
    <h3>{{ 'single_area.itin' | translate }}</h3>
    <div class="filters">
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title *ngIf="!loadingItinThemeIcon; else loadingThemeItinDesktop">
            {{ 'itin_list.filter_theme' | translate }}
          </mat-panel-title>
          <ng-template #loadingThemeItinDesktop>
            <mat-panel-title>
              {{ 'itin_list.filter_theme' | translate }}
              <mat-progress-spinner
                  matSuffix
                  color="primary"
                  mode="indeterminate"
                  [diameter]="24"
                  style="margin-left: 5px;">
              </mat-progress-spinner>
            </mat-panel-title>
          </ng-template>
        </mat-expansion-panel-header>
        <mat-selection-list color="primary" class="dropdown-filters" #themesFilterItinDesktop (selectionChange)="themesFilterFunction('itin', false)">
          <mat-list-option *ngFor="let single_theme of themes_list" [value]="single_theme.name[current_lang]">
            {{single_theme.name[current_lang]}}
          </mat-list-option>
        </mat-selection-list>
      </mat-expansion-panel>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'itin_list.search_label' | translate }}</mat-label>
        <input matInput (keyup)="inputFilter($event, 'itin')" class="input-filter" [placeholder]="'placeholder' | translate">
        <mat-icon *ngIf="!loadingItinSearchIcon; else loadingSearchItinDesktop" matSuffix>search</mat-icon>
        <ng-template #loadingSearchItinDesktop>
          <mat-progress-spinner
              matSuffix
              color="primary"
              mode="indeterminate"
              [diameter]="24">
          </mat-progress-spinner>
        </ng-template>
      </mat-form-field>
    </div>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont headers-with-filters-smaller">
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title *ngIf="!loadingItinThemeIcon; else loadingThemeItinMobile">
          {{ 'itin_list.filter_theme' | translate }}
        </mat-panel-title>
        <ng-template #loadingThemeItinMobile>
          <mat-panel-title>
            {{ 'itin_list.filter_theme' | translate }}
            <mat-progress-spinner
                matSuffix
                color="primary"
                mode="indeterminate"
                [diameter]="24"
                style="margin-left: 5px;">
            </mat-progress-spinner>
          </mat-panel-title>
        </ng-template>
      </mat-expansion-panel-header>
      <mat-selection-list color="primary" class="dropdown-filters" #themesFilterItinMobile (selectionChange)="themesFilterFunction('itin', true)">
        <mat-list-option *ngFor="let single_theme of themes_list" [value]="single_theme.name[current_lang]">
          {{single_theme.name[current_lang]}}
        </mat-list-option>
      </mat-selection-list>
    </mat-expansion-panel>
    <mat-form-field appearance="outline">
      <mat-label>{{ 'itin_list.search_label' | translate }}</mat-label>
      <input matInput (keyup)="inputFilter($event, 'itin')" class="input-filter" [placeholder]="'placeholder' | translate">
      <mat-icon *ngIf="!loadingItinSearchIcon; else loadingSearchItinMobile" matSuffix>search</mat-icon>
      <ng-template #loadingSearchItinMobile>
        <mat-progress-spinner
            matSuffix
            color="primary"
            mode="indeterminate"
            [diameter]="24">
        </mat-progress-spinner>
      </ng-template>
    </mat-form-field>
  </div>
</div>

<div class="single-section">
  <div class="section-cont">
    <div *ngIf="!loadingItin; else loadingPageItin" class="element-card">
      <mat-card *ngFor="let single_itin of itin_list_filtered | paginate: { itemsPerPage: itin_list_size, currentPage: itin_list_page + 1, totalItems: itin_list_total, id: 'paginationItin' }">
        <img mat-card-image [src]="imageUrl(single_itin)" [alt]="single_itin.itin_name[current_lang]">
        <mat-card-content>
          <a [routerLink]="['/home/itinerari/'+single_itin.id]"><h4>{{single_itin.itin_name[current_lang]}}</h4></a>
          <p>{{single_itin.short_descr[current_lang]}}</p>
          <mat-expansion-panel  class="mat-elevation-z0" (click)="togglePanel(single_itin.id)">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon>place</mat-icon>
              </mat-panel-title>
              <mat-panel-description>
                <ng-container *ngIf="single_itin.expanded_panel; else closedPanel">
                  {{ 'itin_list.hide_pois' | translate }}
                </ng-container>
                <ng-template #closedPanel>
                  {{ 'itin_list.show_pois' | translate }}
                </ng-template>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div>
              <ng-container *ngFor="let single_poi of single_itin.pois">
                <a [routerLink]="['/home/poi/' + single_poi.id]"><h4>{{single_poi.poi_name[current_lang]}}</h4></a>
                <p>{{single_poi.short_descr[current_lang]}}</p>
              </ng-container>
            </div>
          </mat-expansion-panel>
        </mat-card-content>
      </mat-card>
    </div>
    <ng-template #loadingPageItin>
      <div class="element-card">
        <mat-progress-spinner
            color="primary"
            mode="indeterminate">
        </mat-progress-spinner>
      </div>
    </ng-template>

    <pagination-controls
      *ngIf="itin_list_total > itin_list_size"
      class="pr-pagination"
      (pageChange)="pageChange($event, false)"
      id="paginationItin"
      [previousLabel]="'paginator.prev' | translate"
      [nextLabel]="'paginator.next' | translate"
    ></pagination-controls>
  </div>
</div>
